export interface Genre {
  id: string;
  name: string;
  desc: string;
  cover: string;
  count: number;
}

export interface Comic {
  id: number;
  title: string;
  genre: string;
  tags: string[];
  cover: string;
  status: string;
  chapters: number;
  likes: number;
  views: string;
  score: number;
  update: string;
  intro: string;
}

export const siteName = '羞羞动漫漫画';

export const genres: Genre[] = [
  {
    id: 'lianai',
    name: '恋爱',
    desc: '从心动到相守，纯爱番的甜蜜日常',
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20a%20young%20couple%20walking%20under%20cherry%20blossoms%2C%20soft%20warm%20peach%20background%2C%20gentle%20smiles%2C%20delicate%20lineart%2C%20romantic%20clean%20composition%2C%20warm%20glowing%20lighting%2C%20sweet%20atmosphere&width=600&height=840&seq=genre-lianai&orientation=portrait',
    count: 328,
  },
  {
    id: 'hougong',
    name: '后宫',
    desc: '多女主群像，选择困难症的快乐源泉',
    cover: 'https://readdy.ai/api/search-image?query=anime%20harem%20romance%20manga%20cover%20of%20a%20happy%20male%20protagonist%20surrounded%20by%20several%20cute%20girls%2C%20soft%20warm%20coral%20background%2C%20cheerful%20expressions%2C%20colorful%20hair%2C%20clean%20anime%20style%2C%20bright%20and%20fun%20atmosphere&width=600&height=840&seq=genre-hougong&orientation=portrait',
    count: 214,
  },
  {
    id: 'aimei',
    name: '暧昧',
    desc: '若即若离的心动，藏在细节里的恋曲',
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20two%20teenagers%20nearly%20touching%20hands%2C%20blushing%20faces%2C%20soft%20warm%20amber%20background%2C%20dreamy%20bokeh%20lights%2C%20delicate%20lineart%2C%20tender%20mood%2C%20romantic%20intimate%20composition&width=600&height=840&seq=genre-aimei&orientation=portrait',
    count: 176,
  },
  {
    id: 'tongju',
    name: '同居',
    desc: '一屋两人三餐四季，生活系恋爱日常',
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20a%20cozy%20couple%20cooking%20breakfast%20in%20a%20warm%20apartment%20kitchen%2C%20soft%20morning%20light%2C%20cream%20and%20peach%20tones%2C%20cozy%20domestic%20atmosphere%2C%20clean%20anime%20style%2C%20gentle%20and%20heartwarming&width=600&height=840&seq=genre-tongju&orientation=portrait',
    count: 142,
  },
  {
    id: 'xiaoyuan',
    name: '校园',
    desc: '课桌与青春，社团教室里的青涩初恋',
    cover: 'https://readdy.ai/api/search-image?query=anime%20school%20romance%20manga%20cover%20of%20students%20under%20a%20campus%20tree%20with%20falling%20leaves%2C%20soft%20warm%20cream%20background%2C%20school%20uniforms%2C%20youthful%20smiles%2C%20clean%20lineart%2C%20nostalgic%20warm%20lighting%2C%20fresh%20and%20sweet&width=600&height=840&seq=genre-xiaoyuan&orientation=portrait',
    count: 259,
  },
  {
    id: 'nihougong',
    name: '逆后宫',
    desc: '女主与各色男主的苏爽心动之旅',
    cover: 'https://readdy.ai/api/search-image?query=anime%20reverse%20harem%20manga%20cover%20of%20a%20beautiful%20female%20protagonist%20with%20several%20handsome%20male%20characters%20around%20her%2C%20soft%20warm%20rose%20background%2C%20elegant%20clothing%2C%20glowing%20atmosphere%2C%20clean%20anime%20style%2C%20romantic%20and%20charming&width=600&height=840&seq=genre-nihougong&orientation=portrait',
    count: 118,
  },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '同桌的秘密信号',
    genre: '校园',
    tags: ['校园', '暧昧', '青涩'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20campus%20romance%20manga%20cover%20of%20a%20boy%20and%20girl%20at%20their%20desks%20glancing%20at%20each%20other%20secretly%2C%20soft%20warm%20cream%20background%2C%20school%20uniforms%2C%20blushing%20cheeks%2C%20clean%20anime%20lineart%2C%20tender%20nostalgic%20lighting%2C%20sweet%20and%20quiet&width=600&height=840&seq=cover-01&orientation=portrait',
    status: '连载中',
    chapters: 88,
    likes: 12864,
    views: '426.5万',
    score: 9.2,
    update: '2小时前',
    intro: '转学而来的优等生与班级里的吊车尾成为同桌，一次意外的小纸条，让两颗心悄悄靠拢。教室里的一举一动，都藏着说不出口的喜欢。',
  },
  {
    id: 2,
    title: '和房东小姐的同居日常',
    genre: '同居',
    tags: ['同居', '恋爱', '治愈'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20a%20young%20couple%20sitting%20close%20on%20a%20sofa%20watching%20tv%20in%20a%20warm%20apartment%2C%20soft%20peach%20background%2C%20cozy%20domestic%20scene%2C%20mugs%20and%20blankets%2C%20gentle%20smiles%2C%20clean%20anime%20style%2C%20warm%20glowing%20lighting%2C%20heartwarming&width=600&height=840&seq=cover-02&orientation=portrait',
    status: '连载中',
    chapters: 132,
    likes: 23408,
    views: '812.7万',
    score: 9.4,
    update: '5分钟前',
    intro: '因为便宜房租搬进的老房子，房东竟是一位温柔又毒舌的小姐姐。从陌生到习惯彼此的存在，原本冰冷的公寓慢慢有了家的温度。',
  },
  {
    id: 3,
    title: '放学后的专属座位',
    genre: '暧昧',
    tags: ['暧昧', '校园', '社团'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20a%20girl%20waiting%20alone%20in%20an%20empty%20classroom%20by%20the%20window%20at%20sunset%2C%20soft%20warm%20amber%20background%2C%20golden%20afternoon%20light%2C%20dreamy%20atmosphere%2C%20clean%20anime%20lineart%2C%20quiet%20and%20romantic&width=600&height=840&seq=cover-03&orientation=portrait',
    status: '已完结',
    chapters: 46,
    likes: 9812,
    views: '308.4万',
    score: 8.8,
    update: '3天前',
    intro: '每天放学后空无一人的教室里，总有一个专属座位在等着某个人。若即若离的距离，让黄昏的光也变得暧昧起来。',
  },
  {
    id: 4,
    title: '五等分的夏日祭',
    genre: '后宫',
    tags: ['后宫', '夏日', '多女主'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20harem%20romance%20manga%20cover%20of%20one%20boy%20surrounded%20by%20five%20cute%20girls%20in%20yukata%20at%20a%20summer%20festival%2C%20soft%20warm%20coral%20background%2C%20festive%20lanterns%2C%20cheerful%20expressions%2C%20clean%20anime%20style%2C%20bright%20joyful%20atmosphere&width=600&height=840&seq=cover-04&orientation=portrait',
    status: '连载中',
    chapters: 96,
    likes: 31027,
    views: '1035.2万',
    score: 9.5,
    update: '1小时前',
    intro: '夏日祭的烟火下，五个性格迥异的少女同时向主角迈出一步。谁才是他真正心动的那一个？答案藏在烟火与浴衣的缝隙里。',
  },
  {
    id: 5,
    title: '转角遇见他',
    genre: '逆后宫',
    tags: ['逆后宫', '恋爱', '都市'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20reverse%20harem%20manga%20cover%20of%20a%20beautiful%20young%20woman%20in%20a%20city%20street%20with%20three%20handsome%20men%20around%20her%2C%20soft%20warm%20rose%20background%2C%20urban%20evening%20light%2C%20elegant%20outfits%2C%20clean%20anime%20style%2C%20charming%20glowing%20atmosphere&width=600&height=840&seq=cover-05&orientation=portrait',
    status: '连载中',
    chapters: 74,
    likes: 17590,
    views: '556.1万',
    score: 9.1,
    update: '30分钟前',
    intro: '普通上班族女主在转角街角接连邂逅几位气质迥异的优质男主，她平淡的生活从此掀起一场苏爽的心动风暴。',
  },
  {
    id: 6,
    title: '青梅竹马的重逢',
    genre: '恋爱',
    tags: ['恋爱', '竹马', '治愈'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20two%20childhood%20friends%20meeting%20again%20under%20a%20tree%20in%20the%20park%2C%20soft%20warm%20cream%20background%2C%20gentle%20smiles%2C%20nostalgic%20warm%20lighting%2C%20clean%20anime%20lineart%2C%20tender%20heartfelt%20mood&width=600&height=840&seq=cover-06&orientation=portrait',
    status: '已完结',
    chapters: 120,
    likes: 20115,
    views: '668.9万',
    score: 9.3,
    update: '1周前',
    intro: '十年后在小镇重聚的青梅竹马，一边修补早已生疏的关系，一边拼回童年时未说出口的约定。',
  },
  {
    id: 7,
    title: '猫咪室友有点甜',
    genre: '同居',
    tags: ['同居', '治愈', '萌宠'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20a%20young%20woman%20holding%20a%20cute%20cat%20next%20to%20a%20gentle%20young%20man%20in%20a%20cozy%20living%20room%2C%20soft%20warm%20peach%20background%2C%20potted%20plants%20and%20sofa%2C%20clean%20anime%20style%2C%20soft%20natural%20lighting%2C%20sweet%20homey%20atmosphere&width=600&height=840&seq=cover-07&orientation=portrait',
    status: '连载中',
    chapters: 67,
    likes: 14503,
    views: '489.2万',
    score: 9.0,
    update: '昨天',
    intro: '合租的室友带来一只黏人的猫咪，也让两个不善表达的人，借着小猫一点点走近彼此的生活。',
  },
  {
    id: 8,
    title: '她来自隔壁班',
    genre: '校园',
    tags: ['校园', '恋爱', '纯爱'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20campus%20romance%20manga%20cover%20of%20a%20shy%20boy%20handing%20a%20note%20to%20a%20smiling%20girl%20at%20the%20school%20hallway%2C%20soft%20warm%20cream%20background%2C%20lockers%20and%20windows%2C%20clean%20anime%20lineart%2C%20bright%20school%20lighting%2C%20fresh%20sweet%20mood&width=600&height=840&seq=cover-08&orientation=portrait',
    status: '连载中',
    chapters: 55,
    likes: 11072,
    views: '365.8万',
    score: 8.9,
    update: '4小时前',
    intro: '隔着一条走廊的距离，是每天偷偷注视的暗恋。一封鼓起勇气的信，把两个原本平行的班级拉近成同心圆。',
  },
  {
    id: 9,
    title: '婚后恋爱的第一天',
    genre: '恋爱',
    tags: ['恋爱', '婚后', '甜宠'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20a%20newlywed%20couple%20in%20matching%20pajamas%20having%20breakfast%20at%20home%2C%20soft%20warm%20coral%20background%2C%20cozy%20morning%20light%2C%20gentle%20expressions%2C%20clean%20anime%20style%2C%20romantic%20domestic%20warmth&width=600&height=840&seq=cover-09&orientation=portrait',
    status: '连载中',
    chapters: 41,
    likes: 12877,
    views: '412.6万',
    score: 9.0,
    update: '昨天',
    intro: '闪婚之后才开始认真恋爱的新婚夫妇，在同居生活的鸡毛蒜皮里，慢慢懂得什么是真正的喜欢。',
  },
  {
    id: 10,
    title: '心跳加速训练营',
    genre: '暧昧',
    tags: ['暧昧', '体育', '社团'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20an%20athletic%20boy%20and%20a%20manager%20girl%20talking%20at%20a%20school%20gym%2C%20soft%20warm%20amber%20background%2C%20sports%20equipment%2C%20sweat%20and%20smiles%2C%20clean%20anime%20lineart%2C%20energetic%20warm%20lighting%2C%20flirty%20atmosphere&width=600&height=840&seq=cover-10&orientation=portrait',
    status: '连载中',
    chapters: 62,
    likes: 9034,
    views: '287.5万',
    score: 8.7,
    update: '2天前',
    intro: '体育社团的训练间隙，一次次近距离的擦肩与对视，让两颗心在汗水和加油声里加速跳动。',
  },
  {
    id: 11,
    title: '与杀手同学的同居',
    genre: '同居',
    tags: ['同居', '反转', '恋爱'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20a%20mysterious%20cool%20girl%20and%20an%20ordinary%20boy%20in%20a%20dim%20apartment%2C%20soft%20warm%20taupe%20background%2C%20moody%20but%20warm%20lighting%2C%20clean%20anime%20style%2C%20mysterious%20romantic%20tension&width=600&height=840&seq=cover-11&orientation=portrait',
    status: '连载中',
    chapters: 38,
    likes: 13205,
    views: '455.3万',
    score: 9.1,
    update: '今天',
    intro: '被黑道追杀的冷酷女同学，意外成了主角的合租室友。她负责保护他的命，他负责教会她好好生活。',
  },
  {
    id: 12,
    title: '王子养成计划',
    genre: '逆后宫',
    tags: ['逆后宫', '养成', '学院'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20reverse%20harem%20manga%20cover%20of%20a%20confident%20female%20lead%20with%20several%20elegant%20male%20academy%20students%20in%20formal%20uniforms%2C%20soft%20warm%20rose%20background%2C%20grand%20academy%20hall%2C%20clean%20anime%20style%2C%20regal%20warm%20lighting%2C%20charming%20atmosphere&width=600&height=840&seq=cover-12&orientation=portrait',
    status: '已完结',
    chapters: 108,
    likes: 22190,
    views: '712.4万',
    score: 9.3,
    update: '5天前',
    intro: '精英学院的学姐受委托培养几位"王子"，却在一路训练中，让傲娇、温润、腹黑各异的他们纷纷沦陷。',
  },
  {
    id: 13,
    title: '雨天的透明伞',
    genre: '暧昧',
    tags: ['暧昧', '校园', '治愈'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20a%20boy%20and%20girl%20sharing%20one%20umbrella%20in%20the%20rain%2C%20soft%20warm%20blue-grey%20rain%20tones%20with%20warm%20glow%2C%20clean%20anime%20lineart%2C%20intimate%20tender%20composition%2C%20romantic%20rainy%20atmosphere&width=600&height=840&seq=cover-13&orientation=portrait',
    status: '连载中',
    chapters: 33,
    likes: 8876,
    views: '276.9万',
    score: 8.8,
    update: '昨天',
    intro: '一场突如其来的大雨，一把撑不大的透明伞，让两个从不打伞的人，有了靠近的理由。',
  },
  {
    id: 14,
    title: '数据组的女王',
    genre: '逆后宫',
    tags: ['逆后宫', '职场', '甜宠'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20a%20confident%20office%20lady%20at%20a%20modern%20workspace%20surrounded%20by%20attractive%20male%20colleagues%2C%20soft%20warm%20coral%20background%2C%20city%20office%20lighting%2C%20elegant%20business%20attire%2C%20clean%20anime%20style%2C%20dynamic%20charming%20atmosphere&width=600&height=840&seq=cover-14&orientation=portrait',
    status: '连载中',
    chapters: 52,
    likes: 16432,
    views: '534.8万',
    score: 9.2,
    update: '6小时前',
    intro: '重返职场的数据组总监，用专业与魅力征服整个项目组，也让几位大佬同事的心都悬在了她的报表上。',
  },
  {
    id: 15,
    title: '番外：冬季的约定',
    genre: '恋爱',
    tags: ['恋爱', '冬日', '特别篇'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20a%20couple%20standing%20in%20snow%20under%20a%20christmas%20tree%2C%20soft%20warm%20white%20and%20gold%20background%2C%20falling%20snowflakes%2C%20scarves%20and%20gloves%2C%20clean%20anime%20lineart%2C%20cozy%20festive%20warm%20lighting%2C%20romantic%20winter%20atmosphere&width=600&height=840&seq=cover-15&orientation=portrait',
    status: '特别篇',
    chapters: 3,
    likes: 6210,
    views: '198.7万',
    score: 8.9,
    update: '2周前',
    intro: '人气恋爱番的冬日番外，在漫天飞雪的圣诞夜，他们许下了属于彼此的约定。',
  },
  {
    id: 16,
    title: '社恐女友的逆袭',
    genre: '恋爱',
    tags: ['恋爱', '成长', '校园'],
    cover: 'https://readdy.ai/api/search-image?query=anime%20romance%20manga%20cover%20of%20a%20shy%20girl%20holding%20a%20notebook%20looking%20up%20at%20a%20warm%20smiling%20boy%2C%20soft%20warm%20cream%20background%2C%20school%20library%2C%20clean%20anime%20lineart%2C%20gentle%20hopeful%20lighting%2C%20sweet%20growth%20story&width=600&height=840&seq=cover-16&orientation=portrait',
    status: '连载中',
    chapters: 49,
    likes: 10770,
    views: '342.1万',
    score: 8.9,
    update: '3小时前',
    intro: '连和陌生人说话都会紧张的社恐少女，在喜欢的人面前，一点点变得勇敢起来。爱情让她成为了更好的自己。',
  },
];